import { ClipboardCheck, ListTodo, CircleDashed, StickyNote, Layers } from 'lucide-react';

export const reportSections = [
  { tipo: 'CONTROLLO', title: 'Cose da controllare', icon: ClipboardCheck, color: '#a21caf', empty: 'Nessun controllo in sospeso.' },
  { tipo: 'TODO', title: 'Cose da fare', icon: ListTodo, color: '#0f766e', empty: 'Nessuna cosa da fare.' },
  { tipo: 'TASK_APERTO', title: 'Task aperti', icon: CircleDashed, color: '#c2410c', empty: 'Nessun task aperto.' },
  { tipo: 'NOTA', title: 'Note / idee', icon: StickyNote, color: '#7c3aed', empty: 'Nessuna nota presente.' },
  { tipo: 'FEATURE', title: 'Funzionalità completate', icon: Layers, color: '#111827', empty: 'Nessuna funzionalità presente.' },
];

export const reportMetrics = [
  ['funzionalita_totali', 'Funzionalità totali', '#111827'],
  ['nuove_ultimo_mese', 'Nuove · <30 giorni', '#dc2626'],
  ['periodo_precedente', 'Periodo precedente · 30–60 giorni', '#2563eb'],
  ['da_controllare', 'Da controllare', '#a21caf'],
  ['cose_da_fare', 'Cose da fare', '#0f766e'],
  ['task_aperti', 'Task aperti', '#c2410c'],
  ['note', 'Note / idee', '#7c3aed'],
];

export const ageLabels = { nuovo: 'Nuova · <30 giorni', precedente: '30–60 giorni', consolidato: 'Consolidata' };
export const ageColors = { nuovo: '#dc2626', precedente: '#2563eb', consolidato: '#111827' };
export const formatDate = (value) => value ? value.split('-').reverse().join('/') : '';

export const reportError = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join(' · ');
  return 'Operazione non riuscita. Riprova.';
};